import FairProducts from './FairProducts.jsx';
import FairProductsAwaiting from './FairProductsAwaiting.jsx';
import FairProductsOfBusiness from './FairProductsOfBusiness.jsx';
import FairProductsReject from './FairProductsReject.jsx';
import FairAddProduct from './FairAddProduct.jsx';
import FairAddProductsOfBusiness from './FairAddProductsOfBusiness.jsx';

export { FairProducts, FairProductsAwaiting, FairProductsOfBusiness, FairProductsReject, FairAddProduct, FairAddProductsOfBusiness }


// WEBPACK FOOTER //
// ./pages/fair/fair-products/index.js